import React from 'react';
import { Column } from '../design-system';
import FieldText from './FieldText';

interface ReadOnlyColumnProps {
  data: any;
  field: any;
  width?: number;
}

const ReadOnlyColumn = ({ data, field, width }: ReadOnlyColumnProps) => {
  return (
    <Column mt={2} pb={3} width={width || 300}>
      <FieldText data={data} {...field} />
    </Column>
  );
};

export default ReadOnlyColumn;
